import { TableBlockConfig } from '@sequencehq/quote-content'
import { BlockAdapter } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/ContentEditor/adapters/blocks/blockAdapter.types'
import { textContentAdapter } from './utils/textContent.adapter'
import { isTableCell } from '@blocknote/core'

export const tableAdapter: BlockAdapter<'table'> = {
  in: block => {
    const config = block.config as TableBlockConfig

    return [
      {
        type: 'table',
        props: { textColor: config.textColor },
        children: [],
        content: {
          type: 'tableContent',
          columnWidths: config.columnWidths,
          headerRows: config.headerRow ? 1 : undefined,
          headerCols: config.headerColumn ? 1 : undefined,
          rows: config.rows.map(row => ({
            cells: row.cells.map(cell => ({
              type: 'tableCell',
              content: textContentAdapter.in(cell.text),
              props: {
                backgroundColor: cell.backgroundColor,
                textColor: cell.textColor,
                textAlignment: cell.textAlignment
              }
            }))
          }))
        }
      }
    ] as ReturnType<BlockAdapter['in']>
  },
  out: () => block => {
    return {
      blockType: 'table',
      config: {
        textColor: block.props.textColor,
        columnWidths: block.content.columnWidths,
        /**
         * headerRows/headerCols naming from Blocknote is a bit odd, as you can only
         * mark the first row and/or column as a header
         */
        headerRow: block.content.headerRows === 1,
        headerColumn: block.content.headerCols === 1,
        rows: block.content.rows.map(row => ({
          cells: row.cells.filter(isTableCell).map(cell => ({
            text: textContentAdapter.out(cell.content),
            backgroundColor: cell.props.backgroundColor,
            textColor: cell.props.textColor,
            textAlignment: cell.props.textAlignment
          }))
        }))
      },
      version: 1
    }
  }
}
